import React, { useRef } from 'react';
import { Link } from 'react-router-dom';

// --- Importa tus imágenes aquí ---
import imgModulo1 from '../../assets/images/modulo1.png'; // Reemplaza con tu imagen
import imgModulo2 from '../../assets/images/modulo2.png'; // Reemplaza con tu imagen
import imgModulo3 from '../../assets/images/modulo3.png'; // Reemplaza con tu imagen
import imgModulo4 from '../../assets/images/modulo4.png'; // Reemplaza con tu imagen
import imgModulo5 from '../../assets/images/modulo5.png'; // Reemplaza con tu imagen

// --- Datos de los módulos del curso ---
const modules = [
  {
    week: 1,
    title: 'Mentalidad: El Origen de tu Realidad',
    description: 'Trabajamos en las creencias que te están limitando y definimos con claridad la nueva versión que quieres crear. Establecemos tu objetivo y tu visión.',
    image: imgModulo1,
  },
  {
    week: 2,
    title: 'Técnicas I: Afirmaciones y Visualización',
    description: 'Avanzamos con técnicas de afirmaciones y visualización para empezar a sembrar las semillas de tu nueva realidad en el campo cuántico.',
    image: imgModulo2,
  },
  {
    week: 3,
    title: 'Técnicas II: Meditación Profunda',
    description: 'Incorporamos meditaciones matutinas guiadas para alinear tu energía y entrar en un estado de creatividad y receptividad desde el inicio del día.',
    image: imgModulo3,
  },
  {
    week: 4,
    title: 'Técnicas III: Respiración Consciente',
    description: 'Utilizamos el poder de la respiración para liberar bloqueos emocionales, elevar tu vibración y anclarte en el presente, el único lugar donde puedes crear.',
    image: imgModulo4,
  },
  {
    week: 5,
    title: 'Plan de Acción: Encarna tu Visión',
    description: 'Diseñamos prácticas concretas para salir de tu zona de confort, tomar acción inspirada y encarnar físicamente la realidad que has estado creando en tu mente.',
    image: imgModulo5,
  }
];

// --- Componente para la tarjeta de un módulo ---
const ModuleCard = ({ week, title, description, image }) => (
  <div className="bg-gray-900/50 rounded-xl overflow-hidden border border-yellow-500/20 shadow-lg shadow-yellow-500/5 transform transition-all duration-500 hover:scale-105 hover:shadow-yellow-500/10">
    <div className="relative w-full h-48 overflow-hidden">
      <img 
        src={image} 
        alt={title} 
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-300"></div>
      <div className="absolute top-3 left-4 [text-shadow:0_2px_5px_rgba(0,0,0,0.8)]">
        <span className="text-yellow-300 text-lg font-bold tracking-wider opacity-80">MÓDULO</span>
        <span className="text-yellow-200 text-5xl font-black opacity-75 -mt-2 block">{`0${week}`}</span>
      </div>
    </div>
    <div className="p-6">
      <h3 className="text-2xl font-bold text-white mb-2">{title}</h3>
      <p className="text-gray-300 font-light">{description}</p>
    </div>
  </div>
);

// --- Iconos para la sección de Beneficios ---
const WhatsAppIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 mx-auto mb-4 text-yellow-400">
        <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
    </svg>
);

const CoachingIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 mx-auto mb-4 text-yellow-400">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9A2.25 2.25 0 0013.5 5.25h-9A2.25 2.25 0 002.25 7.5v9A2.25 2.25 0 004.5 18.75z" />
    </svg>
);

const LifetimeAccessIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 mx-auto mb-4 text-yellow-400">
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.91 11.672a.375.375 0 010 .656l-5.603 3.113a.375.375 0 01-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112z" />
    </svg>
);

const ManifiestaPage = () => {
  const paymentSectionRef = useRef(null);

  const handleScrollToPayment = () => {
    paymentSectionRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  };

  return (
    <div className="bg-black text-white min-h-screen font-sans">
      {/* --- Header --- */}
      <header className="py-12 text-center">
        <h1 className="text-5xl md:text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-600 mb-4 tracking-tight">
          Manifiesta: 5 Semanas para Crear tu Realidad
        </h1>
        <p className="text-xl md:text-2xl text-gray-300 font-light max-w-4xl mx-auto px-4">
          Un viaje intensivo para desbloquear tu poder creador y materializar la vida que deseas.
        </p>
      </header>

      {/* --- Early Call to Action --- */}
      <section className="text-center pb-16 px-4">
        <button
          onClick={handleScrollToPayment}
          className="bg-transparent border-2 border-yellow-400 text-yellow-400 font-bold text-lg py-3 px-10 rounded-full hover:bg-yellow-400 hover:text-black transition-all duration-300 transform hover:scale-105"
        >
          QUIERO INSCRIBIRME AHORA
        </button>
        <p className="mt-3 text-sm text-gray-500 animate-pulse">
          O sigue leyendo para descubrir el camino...
        </p>
      </section>

      {/* --- Módulos del Curso --- */}
      <main className="pt-0 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {modules.map(module => (
              <ModuleCard key={module.week} {...module} />
            ))}
          </div>
        </div>
      </main>

      {/* --- Call to Action - Mercado Pago --- */}
      <section ref={paymentSectionRef} className="py-20 bg-gray-900/50 text-center scroll-mt-20">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-white mb-4">
            ¿Estás listo para tomar el control?
          </h2>
          <p className="text-lg text-gray-300 mb-8 max-w-3xl mx-auto">
            Invierte en ti y en la vida que mereces. Accede a las 5 semanas de transformación y comienza a manifestar tus sueños hoy mismo.
          </p>

          {/* --- Beneficios Incluidos --- */}
          <div className="my-12 text-left">
            <h3 className="text-2xl font-semibold text-yellow-300 mb-8 text-center">Además, con tu inscripción recibes:</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-black/40 p-6 rounded-lg border border-yellow-500/20 transform transition-transform hover:scale-105 duration-300">
                  <WhatsAppIcon />
                  <h4 className="text-xl font-bold text-white text-center">Soporte VIP por WhatsApp</h4>
                  <p className="mt-2 text-gray-400 text-center font-light">
                      Acceso ilimitado en horarios laborales para resolver dudas, compartir tus avances y mantenerte enfocado.
                  </p>
              </div>
              <div className="bg-black/40 p-6 rounded-lg border border-yellow-500/20 transform transition-transform hover:scale-105 duration-300">
                  <CoachingIcon />
                  <h4 className="text-xl font-bold text-white text-center">Coaching Semanal 1-a-1</h4>
                  <p className="mt-2 text-gray-400 text-center font-light">
                      Una sesión de 1 hora para ver tu avance, clarificar conceptos y derribar cualquier bloqueo.
                  </p>
              </div>
              
              <div className="bg-black/40 p-6 rounded-lg border border-yellow-500/20 transform transition-transform hover:scale-105 duration-300">
                  <LifetimeAccessIcon />
                  <h4 className="text-xl font-bold text-white text-center">Acceso de por Vida</h4>
                  <p className="mt-2 text-gray-400 text-center font-light">
                      Al programa con meditaciones grabadas y teoría de metafísica para que repases cuando quieras.
                  </p>
              </div>
            </div>
          </div>


          {/* --- Sección de Precio --- */}
          <div className="my-10 p-6 bg-black/20 rounded-lg border border-yellow-500/30 max-w-md mx-auto">
            <p className="text-sm uppercase tracking-widest text-yellow-400">Oferta por tiempo limitado</p>
            <div className="flex justify-center items-baseline gap-4 my-2">
              <span className="text-3xl text-gray-500 line-through">$770 USD</span>
              <span className="text-5xl font-bold text-yellow-300">$270 USD</span>
            </div>
            <p className="text-gray-400 font-light">
              Solo 3 cupos disponibles para esta transformación intensiva mano a mano.
            </p>
          </div>


          {/* 
            IMPORTANTE: Este es un botón de ejemplo. 
            Debes reemplazarlo con tu link o botón de pago de Mercado Pago.
          */}
          <a 
            href="https://mpago.la/1DK8Qu8" // Reemplazar con el link de pago de Mercado Pago
            className="inline-block bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-black font-bold text-xl py-4 px-12 rounded-full shadow-lg shadow-yellow-500/30 transform hover:scale-105 transition-all duration-300"
          >
            INSCRIBIRME AHORA
          </a>
          <p className="mt-4 text-sm text-gray-500">Pago único. Garantía de por vida.</p>
        </div>
      </section>

      {/* --- Footer --- */}
      <footer className="text-center py-8 border-t border-yellow-500/10">
        <p className="text-sm text-gray-500">&copy; {new Date().getFullYear()} Gus • Aguiar | En misión de elevar y transformar.</p>
        {/* <div className="mt-4">
          <Link to="/" className="text-sm text-gray-400 hover:text-yellow-300 transition-colors">
            Volver al inicio
          </Link>
        </div> */}
      </footer>
    </div>
  );
};

export default ManifiestaPage;